module.exports = __webpack_public_path__ + "img/b1b114b.jpg";